/**
 * Story 053 — 403 page for users without the required role.
 *
 * Per AC3 — direct nav to `/admin/*` as a non-admin lands here with
 * verbatim copy "You don't have permission to access this page. Contact
 * your Tenant Admin."
 */
import type { ReactElement } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { PageHeading } from "@aeriosiq/ui";
import { Link as RouterLink } from "react-router-dom";

export function ForbiddenPage(): ReactElement {
  return (
    <Box
      component="main"
      aria-label="Access denied"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        textAlign: "center",
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ maxWidth: 560 }}>
        <PageHeading>403 — Access denied</PageHeading>
        <Typography variant="body1" color="text.secondary">
          You don&apos;t have permission to access this page. Contact your
          Tenant Admin.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained">
          Back to Dashboard
        </Button>
      </Stack>
    </Box>
  );
}
